export class LazyLoad {
    constructor() {
        this.elements = [];
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        this.paddingScroll = this.screenHeight;
        this.attribute = 'data-src';

        this.onScroll();
    }

    push(element) {
        const data = this.getElemPositionData(element)
        this.elements.push(data);
        this.inView(); // check if element is already in view
    }

    getElemPositionData(element) {
        const {top, bottom} = element.getBoundingClientRect();
        const currentTop = document.documentElement.scrollTop;
        return {
            elem: element,
            top: top + currentTop,
            bottom: bottom + currentTop
        }
    }

    onScroll() {
        window.addEventListener('scroll', () => {
            if(this.elements.length === 0) return;

            this.inView();
        });
    }

    load(item) {
        const elem = item.elem;
        let src = elem.getAttribute(this.attribute);
        if(!src) return;
        
        elem.src = src;
        elem.removeAttribute(this.attribute)
    }

    inView() {
        const {screenHeight, paddingScroll} = this;
        const pos = document.documentElement.scrollTop;
        const bottomPos = pos + screenHeight + paddingScroll;
        const topPos = pos - paddingScroll;

        // no scrolling
        if(document.body.scrollHeight <= this.screenHeight) {
            for(let i = 0 ; i < this.elements.length ; i++) {
                let elem = this.elements.pop();
                this.load(elem);
            }

            return;
        }

        // in view while scroll
        for(let i = 0 ; i < this.elements.length ; i++) {
            let elem = this.elements[i];
            if(bottomPos >= elem.top || (topPos <= elem.top && elem.top <= pos)) {
                this.elements.splice(i, 1);
                this.load(elem);
            }
        }
    }

    clear() {
        this.elements = []; 
    }
}


// WEBPACK FOOTER //
// ./src/helper/lazyLoad.js